<template>
  <div id="my-content">
    <Header/>
    <main id="root">
      <div class="profile">
        <Sidebar/>

        <div class="profile-content profile__associated-artist" v-if="loadFlag">
          <form class="profile-form-edit" enctype='multipart/form-data' @submit.prevent="onSubmitAction">

            <div class="profile-form-header">
              <div class="profile-form-header-top">
                <div class="profile-form-user-photo-wrap">

                  <img v-if="avatarImage"
                       :src="avatarImage"
                       alt="song-image"
                       class="profile-form-user-photo"
                       loading="lazy"
                  >

                  <img v-else
                       src="@/assets/img/default-profile-download.png"
                       alt="Profile image"
                       class="profile-form-user-photo artist-list-item-image-default"
                       loading="lazy"
                  >

                  <div class="profile-form-user-photo-bar">
                    <div class="profile-form-user-photo-bar-background"></div>
                    <div class="profile-form-user-photo-bar-wrap">
                      <div class="profile-form-user-photo-bar-item" @click.stop="changeImagePopup">
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5781 0C5.02403 0 0.521606 4.50243 0.521606 10.0565C0.521606 15.6105 5.02403 20.1129 10.5781 20.1129C16.1321 20.1129 20.6345 15.6105 20.6345 10.0565C20.6345 4.50243 16.1321 0 10.5781 0ZM12.8821 11.7759L11.5848 10.4685V16.0901H9.5735V10.4685L8.27622 11.7759L6.84821 10.3478L10.5792 6.62695L14.3101 10.3579L12.8821 11.7759ZM14.6008 6.03473H6.5556V4.02344H14.6008V6.03473Z"/>
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div class="profile-form__image-verified-item">
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22.2256 11.3126V12.2073C22.2244 14.3046 21.5453 16.3452 20.2896 18.025C19.0339 19.7048 17.2688 20.9336 15.2576 21.5282C13.2464 22.1229 11.0969 22.0515 9.12959 21.3247C7.1623 20.5979 5.48266 19.2546 4.34117 17.4952C3.19968 15.7358 2.6575 13.6545 2.7955 11.5618C2.93349 9.46913 3.74426 7.47709 5.10689 5.88282C6.46952 4.28854 8.311 3.17745 10.3567 2.71526C12.4024 2.25306 14.5427 2.46452 16.4584 3.3181" stroke="#459BCB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M22.2253 4.42683L12.4997 14.1622L9.58203 11.2445" stroke="#459BCB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>

                  <p class="error-profile" v-if="$v.avatarImage.$dirty && !$v.avatarImage.required">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 8V12" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 16H12.01" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>The artist's profile must have a photo</span>
                  </p>

                </div>
              </div>
            </div>

            <div class="profile-section profile-public__info-section">
              <CountrySelect class=""
                             ref="AssociatedArtistCreateCountrySelect"
                             name="countryId"
                             :identifier="'create-associated-artist-country'"
                             :options="searchedCountries"
                             :search-for-name="account.countryId"
                             :placeholder="'Country'"
                             @changed="setCountry"
                             @searchCheck="searchCheck"
              />

              <span class="error-profile"
                    v-if="$v.account.countryId.$dirty && !$v.account.countryId.required"
              >This field is required</span>

            </div>

            <div class="profile-subtitle-wrap">
              <h2 class="profile-subtitle">public information</h2>
            </div>
            <div class="profile-section profile-public__info-section">
              <div class="profile-public__info-about">

                <div class="profile-input-wrapper">
                  <input type="text"
                         name="publicInformation.stageName"
                         id="id_associated_artist_stage_name"
                         placeholder="Stage name"
                         v-model.trim="account.stageName"
                         @input="setFormData"
                         @blur="$v.account.stageName.$touch()"
                  >

                  <span class="error-profile" v-if="$v.account.stageName.$dirty && !$v.account.stageName.required">This field is required</span>
                  <span class="error-profile" v-if="!$v.account.stageName.maxLength">The maximum length of a text message is {{$v.account.stageName.$params.maxLength.max }} characters</span>
                  <span class="error-profile" v-if="!$v.account.stageName.minLength">The minimum length of a text message is {{ $v.account.stageName.$params.minLength.min }} characters</span>
                </div>

                <div class="profile-input-wrapper">
                  <input type="text"
                         name="headline"
                         id="id_headline"
                         placeholder="Occupation (for ex. «singer, songwriter»)"
                         v-model.trim="account.headline"
                         @input="setFormData"
                         @blur="$v.account.headline.$touch()"
                  >
                  <span class="error-profile" v-if="$v.account.headline.$dirty && !$v.account.headline.required">This field is required</span>
                  <span class="error-profile" v-if="!$v.account.headline.maxLength">The maximum length of a text message is {{ $v.account.headline.$params.maxLength.max }} characters</span>
                  <span class="error-profile" v-if="!$v.account.headline.minLength">The minimum length of a text message is {{ $v.account.headline.$params.minLength.min }} characters</span>
                </div>

                <div class="profile-textarea-wrap">
                  <textarea class="profile-textarea"
                            name="description"
                            id="id_description"
                            placeholder="About the artist…"
                            v-model.trim="account.description"
                            @input="setFormData"
                            @blur="$v.account.description.$touch()"
                  >
                  </textarea>
                </div>

                <span class="error-profile" v-if="$v.account.description.$dirty && !$v.account.description.required">This field is required</span>
                <span class="error-profile" v-if="!$v.account.description.maxLength">You can’t use more than {{ $v.account.description.$params.maxLength.max }} characters for your bio</span>
                <span class="error-profile" v-if="!$v.account.description.minLength">Please use at least {{ $v.account.description.$params.minLength.min }} characters for your bio</span>

              </div>

              <div class="profile-public__info-video video-empty">

                <div class="video-wrapper" v-if="account.video" @click="togglePlayVideo">
                  <div class="play-button play-button-video">
                    <div class="hitparad_button-play"
                         :class="videoButtonFlag ? 'hitparad_button-play-active' : 'hitparad_button-pause'"
                    ></div>
                  </div>
                  <video class="my-video" :src="account.video" ref="videoRef"></video>
                </div>

                <div class="video-preview" v-else>
                  <img src="@/assets/img/video_upload.png" alt="Video preview">
                </div>

                <div class="profile-video-hover">
                  <div class="profile-video-hover-download">
                    <svg width="56" height="39" viewBox="0 0 56 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M44.8 5.57143C44.8 4.09379 44.21 2.67668 43.1598 1.63183C42.1096 0.586988 40.6852 0 39.2 0H5.6C4.11479 0 2.69041 0.586988 1.6402 1.63183C0.589998 2.67668 0 4.09379 0 5.57143V33.4286C0 34.9062 0.589998 36.3233 1.6402 37.3682C2.69041 38.413 4.11479 39 5.6 39H39.2C40.6852 39 42.1096 38.413 43.1598 37.3682C44.21 36.3233 44.8 34.9062 44.8 33.4286V24.1438L56 33.4286V5.57143L44.8 14.8562V5.57143ZM33.6 22.2857H25.2V30.6429H19.6V22.2857H11.2V16.7143H19.6V8.35714H25.2V16.7143H33.6V22.2857Z"
                            fill="#B6B6B6"/>
                    </svg>
                    <input type="file" id="id_profile_video" name="fileVideo" class="video-download-btn"
                           accept=".mp4, .m4a, .mov, .ogg, .wmv" @change="setVideo">
                  </div>
                </div>

              </div>

              <div class="public-info">

                <div class="public-info-item">
                  <GeneralSelect class="public-info-select"
                                 :identifier="'associated_artist-info-type'"
                                 :options="publicInfoDTOLists.types"
                                 :current="account.publicInfoDTO.type"
                                 :placeholder="'Type'"
                                 @changed="setInfoType"
                  />

                  <span class="error-profile" v-if="$v.account.publicInfoDTO.type.$dirty && !$v.account.publicInfoDTO.type.required">This field is required</span>
                </div>

                <div class="public-info-item">
                  <GeneralSelect class="public-info-select"
                                 :identifier="'associated_artist-info-genre'"
                                 :options="publicInfoDTOLists.genres"
                                 :current="account.publicInfoDTO.genre"
                                 :placeholder="'Genre'"
                                 @changed="setInfoGenre"
                  />

                  <span class="error-profile" v-if="$v.account.publicInfoDTO.genre.$dirty && !$v.account.publicInfoDTO.genre.required">This field is required</span>
                </div>

                <div class="public-info-item">
                  <GeneralSelect class="public-info-select"
                                 :identifier="'associated_artist-info-status'"
                                 :options="publicInfoDTOLists.statuses"
                                 :current="account.publicInfoDTO.status"
                                 :placeholder="'Status'"
                                 @changed="setInfoStatus"
                  />

                  <span class="error-profile" v-if="$v.account.publicInfoDTO.status.$dirty && !$v.account.publicInfoDTO.status.required">This field is required</span>
                </div>

                <div class="public-info-item">
                  <GeneralSelect class="public-info-select"
                                 :identifier="'associated_artist-info-repertoire'"
                                 :options="publicInfoDTOLists.songRepertoires"
                                 :current="account.publicInfoDTO.songRepertoire"
                                 :placeholder="'Song repertoire'"
                                 @changed="setInfoRepertoire"
                  />

                  <span class="error-profile" v-if="$v.account.publicInfoDTO.songRepertoire.$dirty && !$v.account.publicInfoDTO.songRepertoire.required">This field is required</span>
                </div>

              </div>
            </div>

            <div class="profile-subtitle-wrap">
              <h2 class="profile-subtitle">web &#38; social links<br><span class="addendum">(Please check media contact link)</span></h2>
            </div>
            <div class="registration-form-item registration-social-wrap">
              <div class="registration-field-wrap registration-social-field">
                <div class="input-wrap">
                  <div class="profile-social-input">
                    <div class="registr-input-img-wrap registr-input-img-wrap-twitter">
                      <img src="https://static.djookyawards.com/static/img/twitter-reg.svg" alt="icon">
                    </div>
                    <input
                        type="text"
                        name="socialLinks.twitter"
                        id="id_twitter"
                        placeholder="Link"
                        v-model.trim="account.links.twitter"
                        @input="setFormData"
                        @blur="$v.account.links.twitter.$touch()"
                    >
                    <span class="error-profile" v-if="!$v.account.links.twitter.maxLength">
                      The maximum length of a text message is {{ $v.account.links.twitter.$params.maxLength.max }} characters
                    </span>
                  </div>
                </div>
              </div>
              <div class="registration-field-wrap registration-social-field">
                <div class="input-wrap">
                  <div class="profile-social-input">
                    <div class="registr-input-img-wrap registr-input-img-wrap-instagram">
                      <img src="https://static.djookyawards.com/static/img/instagramm-reg.svg" alt="icon">
                    </div>
                    <input type="text"
                           name="socialLinks.instagram"
                           id="id_instagram"
                           placeholder="Link"
                           v-model.trim="account.links.instagram"
                           @input="setFormData"
                           @blur="$v.account.links.instagram.$touch()"
                    >
                    <span class="error-profile" v-if="!$v.account.links.instagram.maxLength">
                      The maximum length of a text message is {{ $v.account.links.instagram.$params.maxLength.max }} characters
                    </span>
                  </div>
                </div>

              </div>
              <div class="registration-field-wrap registration-social-field">
                <div class="input-wrap">
                  <div class="profile-social-input">
                    <div class="registr-input-img-wrap registr-input-img-wrap-facebook">
                      <img src="https://static.djookyawards.com/static/img/facebook-reg.svg" alt="icon">
                    </div>
                    <input type="text"
                           name="socialLinks.facebook"
                           id="id_facebook"
                           placeholder="Link"
                           v-model.trim="account.links.facebook"
                           @input="setFormData"
                           @blur="$v.account.links.facebook.$touch()"
                    >
                    <span class="error-profile" v-if="!$v.account.links.facebook.maxLength">
                      The maximum length of a text message is {{ $v.account.links.facebook.$params.maxLength.max }} characters
                    </span>
                  </div>
                </div>

              </div>
              <div class="registration-field-wrap registration-social-field">
                <div class="input-wrap">
                  <div class="profile-social-input">
                    <div class="registr-input-img-wrap registr-input-img-wrap-website">
                      <img src="https://static.djookyawards.com/static/img/circle-reg.svg" alt="icon">
                    </div>
                    <input type="text"
                           name="socialLinks.website"
                           id="id_website"
                           placeholder="Link"
                           v-model.trim="account.links.website"
                           @input="setFormData"
                           @blur="$v.account.links.website.$touch()"
                    >
                    <span class="error-profile" v-if="!$v.account.links.website.maxLength">
                      The maximum length of a text message is {{ $v.account.links.website.$params.maxLength.max }} characters
                    </span>
                  </div>
                </div>

              </div>

              <p class="error-profile" v-if="$v.account.links.$dirty && !$v.account.links.objHasValue">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 8V12" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 16H12.01" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>You need to fill in at least one of the fields provided</span>
              </p>

            </div>

            <div class="profile-btn-wrap">
              <button id="user-submit-button"
                      type="submit"
                      class="btn btn-hover profile-btn"
                      name="user_submit"
              >Save Changes</button>
            </div>

          </form>
        </div>

        <div class="preloader-wrapper profile-preloader" v-else>
          <v-progress-circular
              :size="75"
              :width="8"
              color="#FF0090"
              indeterminate
          ></v-progress-circular>
        </div>

      </div>

      <CropImagePopup
          ref="cropImagePopup"
          :imageSrc="image.src"
          :defaultImage="defaultAvatar"
          :aspectRatio="aspectRatio"
          @cropImage="cropImage"
      />
      <ServerErrorPopup ref="serverErrorPopup"
                        :errorMessage="error.errorMessage"
                        :errorTitle="error.errorTitle"
      />

    </main>
    <Footer/>
  </div>
</template>

<script>

import Header from "@/components/header/Header";
import Sidebar from "@/components/profile/Sidebar";
import Footer from "@/components/footer/Footer";
import CropImagePopup from "@/components/popups/CropImagePopup";
import ServerErrorPopup from "@/components/popups/ServerErrorPopup";
import GeneralSelect from "@/components/inputs/GeneralSelect";
import CountrySelect from "@/components/inputs/CountrySelect";
import {required, maxLength, minLength} from "vuelidate/lib/validators";
import scrollToElement from "@/mixins/scrollToElement";

const objHasValue = (obj) => Object.values(obj).some(value => value)


export default {
  name: "CompanyCreateAssociatedArtist",
  data() {
    return {
      checkUploadSong: {},
      account: {
        photo: null,
        countryId: null,
        stageName: null,
        headline: null,
        description: null,
        video: null,
        links: {
          twitter: null,
          instagram: null,
          facebook: null,
          website: null,
        },
        publicInfoDTO: {
          type: null,
          status: null,
          genre: null,
          songRepertoire: null,
        },
      },
      formData: new FormData(),
      publicInfoDTOLists: {},
      countriesList: [],
      searchSelect: '',
      avatarImage: '',
      videoFlag: false,
      profileVideo: '',
      videoButtonFlag: false,
      image: {
        src: '',
      },
      aspectRatio: 3/2,
      defaultAvatar: 'data:image/png;base64,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',
      loadFlag: false,
      error: {
        errorMessage: '',
        errorTitle: '',
      },
    }
  },
  validations() {
    return {
      avatarImage: {
        required
      },
      account: {
        countryId: {
          required
        },
        headline: {
          required,
          maxLength: maxLength(50),
          minLength: minLength(15)
        },
        description: {
          required,
          maxLength: maxLength(1000),
          minLength: minLength(25)
        },
        stageName: {
          required,
          maxLength: maxLength(100),
          minLength: minLength(2)
        },
        links: {
          objHasValue,
          twitter: {
            maxLength: maxLength(150)
          },
          instagram: {
            maxLength: maxLength(150)
          },
          facebook: {
            maxLength: maxLength(150)
          },
          website: {
            maxLength: maxLength(150)
          },
        },
        publicInfoDTO: {
          type: {
            required
          },
          genre: {
            required
          },
          status: {
            required
          },
          songRepertoire: {
            required
          },
        },
      },
    }
  },
  mixins: [scrollToElement],
  methods: {
    onSubmitAction() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        this.scrollToId('my-content')
      } else {
        this.$load(async () => {
          this.loadFlag = false
          await this.$api.associatedArtists.createAssociatedArtist(this.formData)
          await this.$router.push({path: '/profile/associated-artists'})
          this.loadFlag = true
        }, (error) => {
          this.loadFlag = true
          this.scrollToId('my-content')
          this.error.errorMessage = error.data.errors[0].message
          this.$refs.serverErrorPopup.openPopups()
        })
      }
    },
    getObjToArray(obj) {
      let newArray = []
      for (let i in obj) {
        let newObj = {}
        newObj['value'] = +i
        newObj['name'] = obj[i]
        newArray.push(newObj)
      }
      return newArray
    },
    getArrayToFormat(array) {
      let newArray = []
      for (let i in array) {
        let newObj = {}
        newObj['value'] = array[i]
        newObj['name'] = array[i]
        newArray.push(newObj)
      }
      return newArray
    },
    dataRequest() {
      const params = {
        'rule-key': 'associated-artist'
      };

      this.$load(async () => {
        this.loadFlag = false

        let resFirst = await this.$api.profile.getPublicInfo(params)
        let data = resFirst.data.body
        this.publicInfoDTOLists['types'] = this.getObjToArray(data.types)
        this.publicInfoDTOLists['statuses'] = this.getObjToArray(data.statuses)
        this.publicInfoDTOLists['songRepertoires'] = this.getObjToArray(data.songRepertoires)
        this.publicInfoDTOLists['genres'] = this.getArrayToFormat(data.genres)

        let resSecond = await this.$api.countriesLists.getCountries()
        this.countriesList = resSecond.data.body.elements

        this.loadFlag = true
      })
    },
    togglePlayVideo() {
      this.videoFlag = !this.videoFlag
    },
    setVideo(e) {
      const name = e.target.name
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.formData.set(name, files[0])
      this.createVideo(files[0]);
    },
    createVideo(file) {
      const reader = new FileReader();
      const vm = this;

      reader.onload = (e) => {
        vm.account.video = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    changeImagePopup() {
      this.$refs.cropImagePopup.openPopups()
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      let byteCharacters = atob(b64Data);
      let byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      let blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
    cropImage(imageUrl) {
      let block = imageUrl.split(";");
      let contentType = block[0].split(":")[1];// In this case "image/gif"
      let realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
      let blob = this.b64toBlob(realData, contentType);

      this.avatarImage = imageUrl
      this.formData.set('fileAvatar', blob)
    },
    checkUploadSongInfo() {
      this.$load(async () => {
        await this.$api.profileSongs.checkUploadSong().then(res => {
          this.checkUploadSong = res.data.body
        })
      }, error => {
        this.error.serverError = error.data.errors[0].message
        this.$refs.serverErrorPopup.openPopups()
      })
    },
    redirectUrlWithQuery(url, scrollTo) {
      if (url && scrollTo) {
        return url + '?' + scrollTo
      }
    },
    setFormData(event) {
      let dataKey = event.target.name
      let val = event.target.value
      this.formData.set(dataKey, val)
    },
    setInfoType(data) {
      this.formData.set('publicInformation.type', data)
      this.account.publicInfoDTO.type = this.publicInfoDTOLists.types.find(option => option.value.toString().toLowerCase().includes(data.toString().toLowerCase()))
    },
    setInfoGenre(data) {
      this.formData.set('publicInformation.genre', data)
      this.account.publicInfoDTO.genre = this.publicInfoDTOLists.genres.find(option => option.value.toString().toLowerCase().includes(data.toString().toLowerCase()))
    },
    setInfoStatus(data) {
      this.formData.set('publicInformation.status', data)
      this.account.publicInfoDTO.status = this.publicInfoDTOLists.statuses.find(option => option.value.toString().toLowerCase().includes(data.toString().toLowerCase()))
    },
    setInfoRepertoire(data) {
      this.formData.set('publicInformation.songRepertoire', data)
      this.account.publicInfoDTO.songRepertoire = this.publicInfoDTOLists.songRepertoires.find(option => option.value.toString().toLowerCase().includes(data.toString().toLowerCase()))
    },
    setCountry(country) {
      this.formData.set('countryId', country.name)
      this.account.countryId = country.name
    },
    searchCheck(data) {
      this.searchSelect = data
    },
    countryClickOutside(event) {
      if (this.loadFlag) {
        if (!event.target.closest('.general_select')) {
          this.$refs.AssociatedArtistCreateCountrySelect.closeList()
        }
      }
    },

  },
  computed: {
    searchedCountries() {
      return this.countriesList.filter(option => option.name.toLowerCase().includes(this.searchSelect.toLowerCase()))
    },
  },
  watch: {
    videoFlag(newVal) {
      if (newVal) {
        this.$refs.videoRef.play();
        this.videoButtonFlag = true
      } else {
        this.$refs.videoRef.pause()
        this.videoButtonFlag = false
      }
    },
  },
  mounted() {
    document.title = 'Associated artist account'
    document.addEventListener('click', this.countryClickOutside)

    this.dataRequest()

    this.checkUploadSongInfo()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.countryClickOutside)
  },
  components: {
    Header,
    Sidebar,
    Footer,
    ServerErrorPopup,
    GeneralSelect,
    CountrySelect,
    CropImagePopup,
  }
}
</script>

<style scoped>

.error-profile {
  color: red;
  width: auto;
  /*position: absolute;*/
  /*bottom: -20px;*/
  /*left: 0;*/
  margin-bottom: 0;
  display: flex;
  align-items: center;
}

.error-profile svg {
  margin-right: 10px;
  width: 20px;
  height: 20px;
}

.error-profile span {
  width: calc(100% - 30px);
}

.registration-social-wrap .error-profile {
  margin-top: 10px;
}

.public-info-item {
  position: relative;
  width: calc(50% - 10px);
  margin-bottom: 16px;
}

.public-info-item:nth-last-of-type(-n + 2) {
  margin-bottom: 0;
}

.public-info-select.general_select {
  position: relative;
  width: 100%;
  margin-bottom: 0;
}

@media only screen and (max-width: 768px) {
  .public-info-item {
    width: 100%;
  }

  .public-info-item:nth-last-of-type(-n + 2) {
    margin-bottom: 16px;
  }

  .public-info-item:last-of-type {
    margin-bottom: 0;
  }
}

/* disable hover on mobile */
@media only screen and (min-width: 992px) {
  .profile-form-user-photo-bar {
    opacity: 0;
  }

  .profile-form-user-photo-bar:hover,
  .profile-form-user-photo:hover + .profile-form-user-photo-bar {
    opacity: 1;
  }

  .profile-form-user-photo-bar-item:hover path {
    fill: #FE0190;
  }
}

</style>